import { createSagaAction } from '../../../../shared/sagas'
import { createReducer } from '../../../../shared/reducers'

// Constants
export const constants = {
  JOBS_REPORT_GET_ORGANIZATION_LIST: createSagaAction('JOBS_REPORT_GET_ORGANIZATION_LIST'),
  JOBS_REPORT_GET_FULL_REPORT: createSagaAction('JOBS_REPORT_GET_FULL_REPORT')
}

// Action Creators
export const actions = {
  jobsReportGetOrganizationList: ({ filters }) => ({
    type: constants.JOBS_REPORT_GET_ORGANIZATION_LIST.ACTION,
    filters
  }),
  jobsReportGetFullReport: ({ filters }) => ({
    type: constants.JOBS_REPORT_GET_FULL_REPORT.ACTION,
    filters
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.JOBS_REPORT_GET_ORGANIZATION_LIST.ACTION:
      return { ...state, error: null, loadingOrganizationList: true }
    case constants.JOBS_REPORT_GET_ORGANIZATION_LIST.SUCCESS:
      return {
        ...state,
        error: null,
        loadingOrganizationList: false,
        organizationList: action.payload
      }

    case constants.JOBS_REPORT_GET_FULL_REPORT.ACTION:
      return { ...state, error: null, loadingFullReport: true }
    case constants.JOBS_REPORT_GET_FULL_REPORT.SUCCESS:
      return {
        ...state,
        error: null,
        loadingFullReport: false,
        fullReport: action.payload
      }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/reports/jobs/jobsReportActions.js